/* eslint-disable @typescript-eslint/no-explicit-any */
import { Instant } from 'js-joda';
import { oc } from 'ts-optchain';
import _ from 'lodash';

import { ELM_ACTION } from 'middleware/elmActions';
import { ElmPortName, ServiceLocalAction } from 'state/service/appTs/types';
import { logger } from '@tock/logging';
import { safeDispatchServiceAction } from 'utils/service/elmToTsUtils';
import jsToElmPorts from 'actions/service/jsToElmPorts';

export interface RootElmActionReturnType {
  ELM_ACTION: {
    elmPortName: string;
    params: any;
    [key: string]: any;
  };
}

export default function rootElmAction(
  elmPortName: ElmPortName,
  paramToSend: ServiceLocalAction['payload'],
  options = {}
) {
  if (!window.elmApp) {
    logger.error(
      'Elm app has not yet been initialized. Trying to send to elmPortName: ',
      elmPortName
    );
    return { type: 'NOOP' };
  }
  const expectedParamsType = jsToElmPorts[elmPortName];
  if (_.isUndefined(expectedParamsType)) {
    const errorMessage = `Unknown elm port name: ${elmPortName}`;
    logger.error(errorMessage);
    throw new Error(errorMessage);
  }
  logger.debug(`Sending message to elm: ${elmPortName}`, paramToSend);
  window.elmApp.ports[elmPortName].send(paramToSend);
  safeDispatchServiceAction(elmPortName, paramToSend);
  return {
    [ELM_ACTION]: {
      elmPortName,
      params: paramToSend,
      keyToTrack: (oc(options) as any).keyToTrack(null),
      trackAsPostSelectionAction: (oc(options) as any).trackAsPostSelectionAction(false),
    },
  };
}

export function sendLocalAction(
  port: ElmPortName,
  data: Omit<ServiceLocalAction['payload'], 'timestamp'>,
  options = {}
) {
  const payload: ServiceLocalAction['payload'] = {
    ...data,
    timestamp: Math.round(Instant.now().toEpochMilli() / 1000),
  };
  return rootElmAction(port, payload, options);
}
